import {msg} from '@lit/localize';
import {html, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import style from '../../../../scss/choosePlanView.scss';
import {selectCurrentSubscription} from '../../selectors';
import {fetchPlans} from '../../slices/planSlice';
import store from '../../store';

@customElement('arc-choose-plan-view')
export class ChoosePlanView extends connect(store)(LitElement) {
	static styles = [style];

	static properties = {
		loading: {type: String},
		isTrialing: {type: Boolean},
	};

	constructor() {
		super();
		this.loading = '';
		this.subscription = null;
	}

	stateChanged(state) {
		this.loading = state.plan.loading;
		this.subscription = selectCurrentSubscription(state);
	}

	async connectedCallback() {
		super.connectedCallback();
		await store.dispatch(fetchPlans());
	}

	render() {
		let title = msg('Choose a plan');
		if (this.subscription) {
			// show trial end date
			title = msg('Your current subscription');
		}
		return html`
			<div class="choosePlanView">
				<header>
					<h2 class="pageTitle">${title}</h2>
					<arc-subscription-status></arc-subscription-status>
				</header>
				${this.loading === 'plans'
					? html`<div class="loading">${msg('Loading plans!...')}</div>`
					: html`
						<arc-choose-plan></arc-choose-plan>
						<div class="choosePlanViewButtons">
						<arc-customer-portal-button></arc-customer-portal-button>
						<arc-cancel-subscription-button></arc-cancel-subscription-button>
						</div>
					`}
			</div>
		`;
	}
}
